<div class="modal" *ngIf="isOpen" (click)="close()">
    <iframe class="modal__iframe" allowfullscreen="true" [src]="src"></iframe>
</div>
